import { useMemo, useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import { Input, Modal } from "src/components";
import { recoilStates } from "src/recoil/recoilStates";
import { addDays } from "src/utils";
import styled from "styled-components";
import { createTeeshotAxiosInstance } from "../http";
import { useRefetchGroup } from "../hooks";
import AlertModal from "../components/YearBooking/components/common/AlertModal";
import checkCircle from "../assets/images/check_circle.svg";
import checkCircleOff from "../assets/images/check_circle-off.svg";

function Deposit() {
  const [bookingApplication, setBookingApplication] = useRecoilState(
    recoilStates.bookingApplication
  );

  const [group] = useRecoilState(recoilStates.group);

  const clubRelData = useMemo(() => {
    return bookingApplication?.clubRels.find((cr) => [4, 6].includes(cr.year_booking_status_id));
  }, [bookingApplication]);

  const needDeposit = clubRelData?.round_deposit && clubRelData?.year_booking_status_id === 4;

  // const isDone =
  // console.log("clubRelData :", clubRelData);
  const day = addDays(new Date(clubRelData?.updated_at || Date.now()), 7);
  const clubD = clubRelData?.club?.[0];
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAgreed, setIsAgreed] = useState(
    Boolean(
      group?.refund_account_bank_name &&
        group?.refund_account_depositor_name &&
        group?.refund_account_number
    )
  );

  const { onChange: onBankChange, value: bankValue } = Input.hooks.useInput(
    group?.refund_account_bank_name || ""
  );
  const { onChange: onNameChange, value: nameValue } = Input.hooks.useInput(
    group?.refund_account_depositor_name || ""
  );
  const { onChange: onAccountChagne, value: accontValue } = Input.hooks.useInput(
    group?.refund_account_number || ""
  );
  const refetchGroup = useRefetchGroup();

  // group 데이터가 변경될 때마다 체크박스 상태 업데이트
  useEffect(() => {
    const hasRefundAccount = Boolean(
      group?.refund_account_bank_name &&
        group?.refund_account_depositor_name &&
        group?.refund_account_number
    );
    setIsAgreed(hasRefundAccount);
  }, [group]);

  const handleCopyAccount = () => {
    navigator.clipboard.writeText(clubD?.account_number || "");
  };

  const handleRegisterRefundAccount = () => {
    setIsModalOpened(true);
  };

  console.log("group :", group);

  const totalDeposit = (clubRelData?.meal_deposit ?? 0) + (clubRelData?.round_deposit ?? 0);
  const depositorName = `${group?.name}`;

  return (
    <>
      <Container>
        {!needDeposit ? (
          <div className="completion-message">결제완료</div>
        ) : (
          <>
            {/* Alert Message */}
            <div className="alert-message">
              <p>
                해당 예약은 보증금 납부가 필요한 예약입니다. 보증금을 입금하시면{" "}
                <strong>라운드 이후 3일 이내</strong> 등록된 환불계좌로 입금됩니다.
              </p>
            </div>

            {/* Deposit Section */}
            <div className="deposit-section">
              <div className="section-header">
                <h2>보증금</h2>
                <span className="note">*골프장 상황에 따라 변동</span>
              </div>
              <div className="deposit-card">
                <div className="deposit-row">
                  <span className="label total-label">총 결제 금액</span>
                  <span className="amount total-amount">{totalDeposit.toLocaleString()} 원</span>
                </div>
                <div className="deposit-row">
                  <span className="label">보증금(계좌이체)</span>
                  <span className="amount">{totalDeposit.toLocaleString()} 원</span>
                </div>
              </div>
            </div>

            {/* Account Information */}
            <div className="account-section">
              <div className="section-header">
                <h2>보증금 입금계좌</h2>
                <button className="copy-button" onClick={handleCopyAccount}>
                  <svg width="11" height="13" viewBox="0 0 11 13" fill="none">
                    <path
                      d="M4.0385 10.6667C3.70172 10.6667 3.41667 10.5501 3.18333 10.3167C2.95 10.0834 2.83333 9.79836 2.83333 9.46158V1.87191C2.83333 1.53514 2.95 1.25008 3.18333 1.01675C3.41667 0.783415 3.70172 0.666748 4.0385 0.666748H9.62817C9.96494 0.666748 10.25 0.783415 10.4833 1.01675C10.7167 1.25008 10.8333 1.53514 10.8333 1.87191V9.46158C10.8333 9.79836 10.7167 10.0834 10.4833 10.3167C10.25 10.5501 9.96494 10.6667 9.62817 10.6667H4.0385ZM1.70517 13.0001C1.36839 13.0001 1.08333 12.8834 0.85 12.6501C0.616667 12.4167 0.5 12.1317 0.5 11.7949V3.20525H1.5V11.7949C1.5 11.8462 1.52139 11.8932 1.56417 11.9359C1.60683 11.9787 1.65383 12.0001 1.70517 12.0001H8.29483V13.0001H1.70517Z"
                      fill="#FDFDFD"
                    />
                  </svg>
                  계좌번호 복사
                </button>
              </div>
              <div className="account-card">
                <div className="account-row">
                  <span className="label">계좌번호</span>
                  <span className="value">
                    {clubD?.account_bank_name} {clubD?.account_number}
                  </span>
                </div>
                <div className="account-row">
                  <span className="label">예금주</span>
                  <span className="value">{clubD?.account_depositor_name}</span>
                </div>
                <div className="account-row">
                  <span className="label active-label">입금자명</span>
                  <span className="value active-value">{depositorName}</span>
                </div>
                <div className="account-note">*입금자명: 가입자 실명 + 휴대전화 뒤 4자리</div>
              </div>
            </div>

            {/* Agreement Section */}
            <div className="agreement-section">
              <div className="checkbox-row">
                <button className="checkbox" onClick={() => setIsAgreed(!isAgreed)}>
                  <img
                    src={isAgreed ? checkCircle : checkCircleOff}
                    alt={isAgreed ? "checked" : "unchecked"}
                  />
                </button>
                <span className="agreement-text">티샷 예약 약관을 확인하고 이에 동의합니다.</span>
              </div>
            </div>

            {/* Disclaimer */}
            {/* <div className="disclaimer">
              <p>
                티샷은 월단체 부킹에 대한 통신판매중개자이며, 예약과 취소 거래에 대한 책임을 지지
                않습니다.
              </p>
            </div> */}

            {/* Terms Details */}
            {/* <div className="terms-details">
              <p>
                *이용 수수료는 팀당 1만원이며, 보증금은 라운드 이후 영업일 3일내에 환불계좌로 입금됩니다.
              </p>
              <p>
                *본 이용 수수료는 결제일로부터 7일 이내 청약 철회가 가능하며, 결제일 포함 7일 경과 후에는 환불이 불가합니다.
              </p>
              <p>
                *7일 이내 환불 요청시, 부킹 서비스 예약이 취소됩니다.
              </p>
            </div> */}

            {/* CTA Button */}
            <div className="cta-section">
              <button
                className="cta-button"
                onClick={handleRegisterRefundAccount}
                disabled={!isAgreed}
              >
                환불 계좌 등록하기
              </button>
            </div>
          </>
        )}
      </Container>
      {isModalOpened && (
        <Modal
          btnType="confirm-cancel"
          rejectConfirmCondition={!Boolean(bankValue && nameValue && accontValue)}
          rejectConfirmMsg="계좌 정보를 모두 입력하세요."
          onConfirm={async () => {
            setIsLoading(true);
            try {
              const res = await createTeeshotAxiosInstance().post(
                "/yearBooking/group/refundAccount",
                {
                  groupId: group?.id,
                  accountNumber: accontValue,
                  bankName: bankValue,
                  depositor: nameValue,
                }
              );
              if (!res.data.success) {
                throw new Error(res.data.message);
              }
              setIsLoading(false);
              await refetchGroup();
              setShowSuccessModal(true);
            } catch (e: any) {
              setIsLoading(false);
              setErrorMessage(e.message || "오류발생");
              setShowErrorModal(true);
              console.log("e :", e);
            }
          }}
          content={
            <>
              <div className="d-flex fd-c gap-1">
                <Input
                  attr={{
                    placeholder: "은행명",
                    onChange: (e) => {
                      console.log("e :", e);

                      onBankChange(e);
                    },
                    value: bankValue,
                  }}
                />
                <Input
                  attr={{
                    placeholder: "계좌번호",
                    onChange: onAccountChagne,
                    value: accontValue,
                  }}
                />
                <Input
                  attr={{
                    placeholder: "예금주",
                    onChange: onNameChange,
                    value: nameValue,
                  }}
                />
              </div>
            </>
          }
          title="환불계좌 등록"
          setModalState={setIsModalOpened}
        />
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <AlertModal
          title="계좌 등록 성공"
          subtitle="환불계좌가 성공적으로 등록되었습니다."
          confirmText="확인"
          onClose={() => setShowSuccessModal(false)}
          onConfirm={() => setShowSuccessModal(false)}
        />
      )}

      {/* Error Modal */}
      {showErrorModal && (
        <AlertModal
          title="오류 발생"
          subtitle={errorMessage}
          confirmText="확인"
          onClose={() => setShowErrorModal(false)}
          onConfirm={() => setShowErrorModal(false)}
        />
      )}
    </>
  );
}

export default Deposit;

const Container = styled.div`
  width: 100%;
  background: #fdfdfd;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0 auto;
  overflow: hidden;
  padding: 16px;
  box-sizing: border-box;

  .completion-message {
    text-align: center;
    padding: 50px 0;
    font-size: 18px;
    font-weight: 700;
    color: #004b49;
  }

  /* Alert Message */
  .alert-message {
    display: flex;
    width: 100%;
    padding: 8px 12px;
    align-items: center;
    border-radius: 6px;
    background: #ffeded;
    margin-bottom: 20px;
    min-height: 58px;
  }

  .alert-message p {
    color: #ff4949;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    margin: 0;
  }

  .alert-message strong {
    font-weight: 700;
  }

  /* Deposit Section */
  .deposit-section {
    margin-bottom: 20px;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 10px;
  }

  .section-header h2 {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin: 0;
  }

  .note {
    color: #79818a;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  .deposit-card {
    width: 100%;
    border-radius: 6px;
    background: #f0f0f4;
    padding: 16px;
    box-sizing: border-box;
  }

  .deposit-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .deposit-row:last-child {
    margin-bottom: 0;
  }

  .label {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #1a1a1a;
  }

  .total-label {
    color: #f97000;
  }

  .amount {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: #1a1a1a;
  }

  .total-amount {
    color: #f97000;
  }

  /* Account Section */
  .account-section {
    margin-bottom: 20px;
  }

  .copy-button {
    display: inline-flex;
    padding: 6px;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    background: #007bff;
    border: none;
    color: #fdfdfd;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    cursor: pointer;
    height: 30px;
  }

  .copy-button svg {
    width: 16px;
    height: 16px;
  }

  .account-card {
    width: 100%;
    border-radius: 6px;
    background: #f0f0f4;
    padding: 16px;
    box-sizing: border-box;
  }

  .account-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .account-row:last-of-type {
    margin-bottom: 16px;
  }

  .value {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: #1a1a1a;
    text-align: right;
  }

  .active-label {
    color: #007bff;
  }

  .active-value {
    color: #007bff;
  }

  .account-note {
    color: #79818a;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  /* Agreement Section */
  .agreement-section {
    margin-bottom: 20px;
  }

  .checkbox-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .checkbox {
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .checkbox img {
    width: 24px;
    height: 24px;
  }

  .agreement-text {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  /* Disclaimer */
  .disclaimer {
    margin-bottom: 20px;
  }

  .disclaimer p {
    color: #79818a;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    margin: 0;
  }

  /* Terms Details */
  .terms-details {
    display: flex;
    width: 100%;
    padding: 12px;
    align-items: flex-start;
    border-radius: 6px;
    background: #f0f0f4;
    margin-bottom: 20px;
    box-sizing: border-box;
    flex-direction: column;
  }

  .terms-details p {
    color: #79818a;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin: 0 0 8px 0;
    width: 100%;
  }

  .terms-details p:last-child {
    margin-bottom: 0;
  }

  /* CTA Section */
  .cta-section {
    margin-bottom: 20px;
  }

  .cta-button {
    display: flex;
    width: 100%;
    height: 60px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #004b49;
    border: none;
    color: #fdfdfd;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    cursor: pointer;
    box-sizing: border-box;
  }

  .cta-button:disabled {
    background: #d1d5d8;
    color: #79818a;
    cursor: not-allowed;
  }

  .cta-button:hover:not(:disabled) {
    background: #003d3b;
  }

  @media (max-width: 390px) {
    width: 100%;
    min-width: 320px;
    padding: 16px;
  }
`;
